// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__OnEUL","circle":"loading_circle__X3q+m","spinner-c7wet2":"loading_spinner-c7wet2__DbytD"};